import React, { FC } from 'react';
import styled from 'styled-components';

import KiteInSky from '../../assets/icons/kite-in-sky.svg';
import { colors, MOBILE_BREAKPOINT } from '../constants';

import { PrimaryButton } from './Button';
import Heading from './Heading';
import { ModalProps, ModalWrapper } from './ModalWrapper';

// Styles -----------------------------------------------------------------------------------------
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  width: 23rem;
  margin: 0;
  padding-top: 1rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    width: 32rem;
    padding-top: 0;
    height: 100%;
  }
`;
ContentContainer.displayName = 'ErrorModal';

const KiteIcon = styled(KiteInSky)`
  margin-bottom: 1.25rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    width: 3.0625rem;
    height: 3.25rem;
    margin-bottom: 0.5rem;
  }
`;
KiteIcon.displayName = 'KiteIcon';

const ErrorModalHeading = styled(Heading)`
  margin: 0 2.75rem 1.25rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 1rem 1.25rem;
  }
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    margin: 0;
  }
`;
ErrorModalHeading.displayName = 'ErrorModalHeading';

// Conditional div that allows subtext and phone number on the same line
const SubTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: row;
  }
`;
SubTextContainer.displayName = 'SubTextContainer';

const SubText = styled.p`
  color: ${colors.TEXT_PRIMARY};
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  margin-bottom: 0.375rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    margin: 0.125rem;
  }
`;
SubText.displayName = 'SubText';

const PhoneNumber = styled.p`
  font-size: 1.375rem;
  line-height: 1.5rem;
  color: ${colors.TEXT_ACTION};
  margin-bottom: 0.375rem;
  font-weight: 400;
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    font-size: 1rem;
    padding-top: 0.5rem;
  }
`;
PhoneNumber.displayName = 'PhoneNumber';

const ContinueButton = styled(PrimaryButton)`
  width: 19rem;
  height: 3.5rem;
  margin: 2.25rem 0;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 19.4375rem;
  }
  @media (max-height: ${MOBILE_BREAKPOINT}) and (min-width: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 0;
  }
`;
ContinueButton.displayName = 'ContinueButton';

// Component --------------------------------------------------------------------------------------
export const ErrorModal: FC<ModalProps> = ({ showModal, setShowModal }) => (
  <ModalWrapper
    id="error-modal"
    showModal={showModal}
    setShowModal={setShowModal}
  >
    <ContentContainer>
      <KiteIcon />
      <ErrorModalHeading>
        Sorry, something went wrong on our end
      </ErrorModalHeading>
      <SubTextContainer>
        <SubText>Try again or call us at</SubText>
        <PhoneNumber>1 (800) 851-0630</PhoneNumber>
        <SubText>from 9am-7pm EST Mon-Fri</SubText>
      </SubTextContainer>
      <ContinueButton
        id="error-modal-continue-button"
        onClick={() => setShowModal(false)}
      >
        Continue
      </ContinueButton>
    </ContentContainer>
  </ModalWrapper>
);
